import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Translators } from 'src/app/services/shared/translators.service';
@Component({
  selector: 'app-proteccion-de-datos',
  templateUrl: './proteccion-de-datos.component.html',
  styleUrls: ['./proteccion-de-datos.component.scss']
})
export class ProteccionDeDatosComponent implements OnInit {

  lenguaje = 'es';
  idioma: Subscription;

  constructor(
    private translatorService: Translators,
  ) {
    this.idioma = this.translatorService.getIdiomaSeleccionado().subscribe(resp => {
      switch (resp.value){
        case 'es':
          this.lenguaje = 'es';
          break;
        case 'en':
          this.lenguaje = 'en';
          break;
        default:
          this.lenguaje = 'es';
          break;
        }
    });
  }

  ngOnInit(): void {
  }

  useLanguage(idioma: string){
    this.translatorService.setIdiomaSeleccionado(idioma);
  }




}
